@if(pageService.viewDroplistItems.length){
<div class='delivery-events-views-part'>
	@if(pageService.selectedViewItem(); as selectedViewItem){
	<droplist class="views-droplist" [items]='pageService.viewDroplistItems' [selectedItem]='selectedViewItem' (selectionChange)='pageService.onViewDroplistChange($event)' [filterable]='false' [navigation]='true' sortBy='customSort' style='display:inline-block'> </droplist>
	@switch (selectedViewItem.uniqueId) {
	@case (pageService.viewId.UpcomingEvents) {
	<delivery-upcoming-events-view-part></delivery-upcoming-events-view-part>
	}
	@case (pageService.viewId.PastEvents) {
	<delivery-past-events-view-part></delivery-past-events-view-part>
	}
	}
	}
</div>
}